<template>
  <div>
    <JoinWrapper v-if="isPc || isTablet" page-type="cart">
      <div class="box_wrap" data-detail="cart_detail">
        <!-- PROGRESS BAR START -->
        <div class="cart_progress">
          <div class="progress_box active">
            <p class="cell">
              <span class="fn_mont">{{ $t('views.cart.cart.2686') }}</span>
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{ $t('views.cart.cart.170') }}</span>
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{ $t('views.cart.cart.4758') }}</span>
            </p>
          </div>
        </div>
        <!-- PROGRESS BAR END -->

        <!-- EBOOK SECTION START -->
        <div v-if="showEbook" class="box" data-detail="margin_0">
          <!-- EBOOK SECTION TITLE START -->
          <dl class="order_title">
            <dt>
              <span class="c_icon ico_cart_ebook"></span
              >{{ $t('views.cart.cart.8715') }}
            </dt>
            <dd>{{ $t('views.cart.cart.4803') }}</dd>
          </dl>
          <!-- EBOOK SECTION TITLE END -->
          <div class="check_all_box">
            <div class="join_check check_all">
              <div class="text_label" @click.prevent="selectAll(false)">
                <label
                  ><input
                    v-model="allSelected"
                    type="checkbox"
                    name=""
                    class="chk_agree"
                  /><em></em><span>전체 선택</span></label
                >
              </div>
              <div class="btn_wrap select_del">
                <button
                  type="button"
                  name="button"
                  class="box_btn line"
                  @click="removeSelected"
                >
                  <span class="an_t">선택 삭제</span>
                </button>
              </div>
            </div>
          </div>
          <!-- EBOOK LIST SECTION START -->
          <ul v-if="getCart" class="order_book" data-detail="cart_1">
            <li
              v-for="item in getEbook"
              :key="`${item.cartCd}-${item.cartGoodsSeq}`"
              class="join_check"
            >
              <div class="text_label">
                <label>
                  <input
                    v-model="ebookSelected"
                    type="checkbox"
                    name="agree"
                    class=""
                    :title="item.bookNm + `선택`"
                    :value="item"
                    @change="handleEbookChange"
                  />
                  <em></em>
                  <span>{{ item.bookNm }}선택</span>
                </label>
              </div>

              <div class="cover_wrap">
                <router-link
                  class="thum_wrap"
                  :to="{ name: 'book_detail', params: { id: item.bookCd } }"
                >
                  <img :src="item.thumbUrl" :alt="item.bookNm" />
                </router-link>
              </div>

              <div class="info_wrap">
                <h3 class="meta_title">
                  {{
                    item.bookNm ||
                    '학교에서 알려주지 않는 17가지 실무 개발 기술'
                  }}
                </h3>
                <p>
                  <span class="meta_author">{{ item.author }}</span>
                  <span class="gap">/</span>
                  <span class="meta_publisher">{{ item.publisher }}</span>
                </p>
                <span class="meta_option base_CT16">{{
                  item.options.optDesc
                }}</span>
                <div
                  v-if="item.goodsTp === 'BUNDLE'"
                  class="set_book"
                  style="margin-top: 6px; font-size: 12px; color: red;"
                >
                  * 해당 상품은 환불불가 상품입니다.
                </div>
              </div>

              <div class="price_wrap">
                <ul class="meta_detail">
                  <li>
                    <p class="meta_price">
                      <span v-if="item.listAmt > item.saleAmt" class="discount">
                        <span class="price">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="item.listAmt"
                          />
                          원
                        </span>
                      </span>
                      <span v-if="item.listAmt > item.saleAmt" class="percent"
                        >( {{ item.discountPercent
                        }}<span class="arrow">{{
                          $t('views.cart.cart.discount')
                        }}</span>
                        )</span
                      >
                      <span class="blind">{{
                        $t('views.cart.cart.4694')
                      }}</span>
                      <strong>
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="decimal"
                          :currency="getCurrency.currency"
                          :number="item.saleAmt"
                        />
                        원
                      </strong>
                    </p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- EBOOK SECTION END -->
        <!-- EBOOK SECTION START -->
        <!-- 선물 주석 -->
        <div v-if="showGift" class="box" data-detail="margin_0">
          <dl class="order_title">
            <dt>
              <span class="c_icon ico_cart_ebook"></span>

              선물 구매
            </dt>
            <dd>{{ $t('views.cart.cart.4803') }}</dd>
          </dl>

          <div class="check_all_box">
            <div class="join_check check_all">
              <div class="text_label" @click.prevent="selectAll(true)">
                <label
                  ><input
                    v-model="allGiftSelected"
                    type="checkbox"
                    name=""
                    class="chk_agree"
                  /><em></em
                  ><span>{{ $t('views.cart.cart.6388') }}</span></label
                >
              </div>
              <div class="btn_wrap select_del">
                <button
                  type="button"
                  name="button"
                  class="box_btn line"
                  @click="removeSelected"
                >
                  <span class="an_t">선택 삭제</span>
                </button>
              </div>
            </div>
          </div>

          <ul v-if="getCart" class="order_book" data-detail="cart_1">
            <li
              v-for="item in getGift"
              :key="`${item.cartCd}-${item.cartGoodsSeq}`"
              class="join_check"
            >
              <div class="text_label">
                <label>
                  <input
                    v-model="giftSelected"
                    type="checkbox"
                    name="agree"
                    class=""
                    :title="item.bookNm + `선택`"
                    :value="item"
                    @change="handleGiftChange"
                  />
                  <em></em>
                  <span>{{ item.bookNm }}선택</span>
                </label>
              </div>

              <div class="cover_wrap">
                <router-link
                  class="thum_wrap"
                  :to="{ name: 'book_detail', params: { id: item.bookCd } }"
                >
                  <img :src="item.thumbUrl" :alt="item.bookNm" />
                </router-link>
              </div>

              <div class="info_wrap">
                <h3 class="meta_title">
                  {{
                    item.bookNm ||
                    '학교에서 알려주지 않는 17가지 실무 개발 기술'
                  }}
                </h3>
                <p>
                  <span class="meta_author">{{ item.author }}</span>
                  <span class="gap">/</span>
                  <span class="meta_publisher">{{ item.publisher }}</span>
                </p>
                <span class="meta_option base_CT16">{{
                  item.options.optDesc
                }}</span>
              </div>

              <div class="price_wrap">
                <ul class="meta_detail">
                  <li>
                    <p class="meta_price">
                      <span v-if="item.listAmt > item.saleAmt" class="discount">
                        <span class="price">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="item.listAmt"
                          />
                        </span>
                      </span>
                      <span v-if="item.listAmt > item.saleAmt" class="percent"
                        >( {{ item.discountPercent
                        }}<span class="arrow">{{
                          $t('views.cart.cart.discount')
                        }}</span>
                        )</span
                      >
                      <span class="blind">{{
                        $t('views.cart.cart.4694')
                      }}</span>
                      <strong>
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="decimal"
                          :currency="getCurrency.currency"
                          :number="item.saleAmt"
                        />
                        원
                      </strong>
                    </p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- EBOOK SECTION END -->

        <div class="box">
          <div class="total_price_wrap">
            <div class="table_wrap flex">
              <div>
                <span class="dt">{{ $t('views.cart.cart.2451') }}</span>
                <span class="dd">
                  <strong class="price">{{ totalSelectedCount }}</strong
                  ><span class="currency">{{
                    $t('views.cart.cart.items')
                  }}</span>
                </span>
              </div>
              <div class="c_icon ico_cart_equals"></div>
              <div>
                <span class="dt">{{ $t('views.cart.cart.9501') }}</span>
                <span class="dd total_price">
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="decimal"
                      :currency="getCurrency.currency"
                      :number="totalOrderPrice"
                    />
                    원
                  </strong>
                </span>
              </div>
            </div>
          </div>

          <div class="btn_wrap" data-detail="btn_bottom">
            <!-- 선물 주석 -->
            <button
              v-if="showGift"
              class="gift_btn"
              @click="toOrderStep2(true)"
            >
              선물하기
            </button>
            <button class="buy_btn" @click="toOrderStep2()">구매하기</button>
          </div>
        </div>
      </div>

      <!-- 장바구니 END -->
    </JoinWrapper>

    <JoinWrapper v-if="isMobile" page-type="cart">
      <section data-detail="cart_detail">
        <!-- PROGRESS BAR START -->
        <div class="cart_progress">
          <div class="progress_box active">
            <p class="cell">
              <span class="fn_mont">01. 장바구니</span>
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">02. 주문 / 결제</span>
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">03. 주문완료</span>
            </p>
          </div>
        </div>
        <!-- PROGRESS BAR END -->

        <!-- EBOOK SECTION START -->
        <div v-if="showEbook" class="box" data-detail="margin_0">
          <div class="join_check check_all layout">
            <div class="chk_wrap">
              <input
                id="checkinput_all"
                v-model="allSelected"
                type="checkbox"
                class="checkinput all"
              />
              <label for="checkinput_all" @click.prevent="selectAll(false)"
                >전체 선택</label
              >
              <span class="total_selected"
                >총 {{ ebookSelected.length }}개</span
              >
            </div>
            <button
              type="button"
              name="button"
              class="selected_remove"
              @click="removeSelected"
            >
              선택 삭제
            </button>
          </div>
          <!-- 전자책 장바구니(선물x) -->
          <ul v-if="getCart" class="cart_list" data-detail="cart_1">
            <li
              v-for="item in getEbook"
              :key="`${item.cartCd}-${item.cartGoodsSeq}`"
              class=""
            >
              <div class="item_box">
                <input
                  :id="`chk_book_${item.idx}`"
                  v-model="ebookSelected"
                  :title="item.bookNm + `선택`"
                  :value="item"
                  type="checkbox"
                  name="agree"
                  class="checkinput"
                  @change="handleEbookChange"
                />
                <label :for="`chk_book_${item.idx}`">
                  <figure class="cover_wrap">
                    <router-link
                      class="thum_wrap"
                      :to="{ name: 'book_detail', params: { id: item.bookCd } }"
                    >
                      <img :src="item.thumbUrl" :alt="item.bookNm" />
                    </router-link>
                    <figcaption>
                      <div class="info_wrap">
                        <h3 class="book_title">
                          {{
                            item.bookNm ||
                            '학교에서 알려주지 않는 17가지 실무 개발 기술'
                          }}
                        </h3>
                        <!-- <p>
                          <span class="meta_author">{{ item.author }}</span>
                          <span class="gap">/</span>
                          <span class="meta_publisher">{{
                            item.publisher
                          }}</span>
                        </p> -->
                        <span class="meta_option base_CT16">{{
                          item.options.optDesc
                        }}</span>
                        <div class="meta_price">
                          <div>
                            <s
                              v-if="item.listAmt > item.saleAmt"
                              class="discount"
                              style="color: #a3a3a3;"
                            >
                              <vue-intl-numberformat
                                locale="ko-KR"
                                format-style="decimal"
                                :currency="getCurrency.currency"
                                :number="item.listAmt"
                              />원
                            </s>
                            <span
                              v-if="item.listAmt > item.saleAmt"
                              class="percent"
                            >
                              ({{ item.discountPercent
                              }}<span
                                class="arrow"
                                style="width: 10px; height: 10px;"
                              ></span
                              >)
                            </span>
                          </div>
                          <span class="blind">{{
                            $t('views.cart.cart.4694')
                          }}</span>
                          <strong>
                            <vue-intl-numberformat
                              locale="ko-KR"
                              class="value"
                              format-style="decimal"
                              :currency="getCurrency.currency"
                              :number="item.saleAmt"
                            />
                            원
                          </strong>
                        </div>
                        <div
                          v-if="item.goodsTp === 'BUNDLE'"
                          class="set_book"
                          style="margin-top: 6px; font-size: 12px; color: red;"
                        >
                          * 해당 상품은 환불불가 상품입니다.
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </label>
              </div>
            </li>
          </ul>
        </div>
        <!-- EBOOK SECTION END -->
        <!-- 구분선 -->
        <div v-if="showGift" class="division_line">선물하기</div>
        <!-- gift SECTION START -->
        <!-- 선물 주석 -->
        <div v-if="showGift" class="box" data-detail="margin_0">
          <div class="join_check check_all layout">
            <div class="chk_wrap">
              <input
                id="checkinput_all"
                v-model="allGiftSelected"
                type="checkbox"
                class="checkinput all"
              />
              <label for="checkinput_all" @click.prevent="selectAll(true)"
                >전체 선택</label
              >
              <span class="total_selected">총 {{ giftSelected.length }}개</span>
            </div>
            <button
              type="button"
              name="button"
              class="selected_remove"
              @click="removeSelected"
            >
              선택 삭제
            </button>
          </div>
          <!-- 선물 장바구니 -->
          <ul v-if="getCart" class="cart_list" data-detail="cart_1">
            <li
              v-for="item in getGift"
              :key="`${item.cartCd}-${item.cartGoodsSeq}`"
              class=""
            >
              <div class="item_box">
                <input
                  :id="`chk_gift_${item.idx}`"
                  v-model="giftSelected"
                  :title="item.bookNm + `선택`"
                  :value="item"
                  type="checkbox"
                  name="agree"
                  class="checkinput"
                  @change="handleGiftChange"
                />
                <label :for="`chk_gift_${item.idx}`">
                  <figure class="cover_wrap">
                    <router-link
                      class="thum_wrap"
                      :to="{ name: 'book_detail', params: { id: item.bookCd } }"
                    >
                      <img :src="item.thumbUrl" :alt="item.bookNm" />
                    </router-link>
                    <figcaption>
                      <div class="info_wrap">
                        <h3 class="book_title">
                          {{
                            item.bookNm ||
                            '학교에서 알려주지 않는 17가지 실무 개발 기술'
                          }}
                        </h3>
                        <!-- <p>
                          <span class="meta_author">{{ item.author }}</span>
                          <span class="gap">/</span>
                          <span class="meta_publisher">{{
                            item.publisher
                          }}</span>
                        </p> -->
                        <span class="meta_option base_CT16">{{
                          item.options.optDesc
                        }}</span>
                        <div class="meta_price">
                          <span
                            v-if="item.listAmt > item.saleAmt"
                            class="discount"
                          >
                            <span class="price">
                              <vue-intl-numberformat
                                locale="ko-KR"
                                class="price"
                                format-style="decimal"
                                :currency="getCurrency.currency"
                                :number="item.listAmt"
                              />
                              원
                            </span>
                          </span>
                          <span
                            v-if="item.listAmt > item.saleAmt"
                            class="percent"
                            >( {{ item.discountPercent
                            }}<span class="arrow">{{
                              $t('views.cart.cart.discount')
                            }}</span>
                            )</span
                          >
                          <span class="blind">{{
                            $t('views.cart.cart.4694')
                          }}</span>
                          <strong>
                            <vue-intl-numberformat
                              locale="ko-KR"
                              class="value"
                              format-style="decimal"
                              :currency="getCurrency.currency"
                              :number="item.saleAmt"
                            />
                            원
                          </strong>
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </label>
              </div>
            </li>
          </ul>
        </div>
        <!-- EBOOK SECTION END -->

        <div class="box">
          <div class="total_price_wrap">
            <div class="table_wrap flex">
              <div>
                <span class="dt">선택된 상품</span>
                <span class="dd">
                  <strong class="price">{{ totalSelectedCount }}</strong
                  ><span class="currency">{{
                    $t('views.cart.cart.items')
                  }}</span>
                </span>
              </div>
              <div class="c_icon ico_cart_equals"></div>
              <div>
                <span class="dt">총 주문금액</span>
                <span class="dd total_price">
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="decimal"
                      :currency="getCurrency.currency"
                      :number="totalOrderPrice"
                    />
                    원
                  </strong>
                </span>
              </div>
            </div>
          </div>

          <div
            class="btn_wrap"
            :class="{ 'center': !showGift }"
            data-detail="btn_bottom"
          >
            <!-- 선물 주석 -->
            <button
              v-if="showGift"
              class="gift_btn"
              @click="toOrderStep2(true)"
            >
              선물하기
            </button>
            <button v-if="showEbook" class="buy_btn" @click="toOrderStep2()">
              구매하기
            </button>
          </div>
        </div>
      </section>

      <!-- 장바구니 END -->
    </JoinWrapper>

    <!-- ERROR MODAL START -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <button class="btn_ly_close svg_close" @click="toggleErrorModal">
                <span>닫기</span>
              </button>
            </div>
            <div class="ly_inner">
              <p style="white-space: pre-line;">
                {{
                  customErrMsg ? customErrMsg : $t('views.cart.cart.select1')
                }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleErrorModal">
                  <span class="an_t">닫기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <transition v-on-clickaway="toggleCompleteModal" name="modal-fade">
      <Modal v-if="showCompleteModal" @close="toggleCompleteModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <button
                class="btn_ly_close svg_close"
                @click="toggleCompleteModal"
              >
                <span>닫기</span>
              </button>
            </div>
            <div class="ly_inner">
              <p>
                {{ completeMsg }}
              </p>
              <span class="base_FT14">{{ completeSubMsg }}</span>
              <div class="btnWrap complete-wrap">
                <button class="box_btn dull" @click="toggleCompleteModal">
                  <span class="an_t">닫기</span>
                </button>
                <!-- <button class="box_btn" @click="validTerminal">
                  <span class="an_t">확인</span>
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
import { hidePaperBook } from '@/store/constants'
import responsiveMixin from '@/mixins/responsive'
import { mapGetters } from 'vuex'
import {
  CART_GET_LIST,
  CART_UPDATE_ITEM,
  CART_REMOVE_ITEM
} from '@/store/types'

const initialState = () => {
  return {
    allSelected: false,
    ebookSelected: [],
    giftSelected: [],
    showErrorModal: false,
    showCompleteModal: false,
    hidePaperBook,
    isWebView: false,
    customErrMsg: '',
    allGiftSelected: false,
    completeMsg: '',
    completeSubMsg: '',
    buyCurrentTp: 'PMT',
    podSelected: []
  }
}

export default {
  name: 'Cart',
  components: {
    JoinWrapper
  },
  mixins: [responsiveMixin],
  data() {
    return initialState()
  },
  computed: {
    ...mapGetters(['isCartLoading', 'getCart', 'getCurrency']),

    showEbook() {
      if (this.getEbook?.length > 0) return true
      return false
    },
    showGift() {
      if (this.getGift?.length > 0) return true
      return false
    },
    eBookSelectedValid() {
      const x = this.ebookSelected.find((e) => {
        return !e
      })
      return x ? false : true
    },
    giftSelectedValid() {
      const x = this.podSelected.find((e) => {
        return !e
      })
      return x ? false : true
    },
    getEbook() {
      if (!this.getCart || !this.getCart.ebookCartList) {
        return []
      }
      let xx = this.getCart.ebookCartList
      if (this.getCurrency.currency !== 'KRW') {
        xx.forEach((e) => {
          const y = e.currencies.find(
            (x) => x.currencyTp === this.getCurrency.currency
          )
          e.listAmt = y.listAmt
          e.saleAmt = y.saleAmt
        })
      }
      return xx
    },
    getGift() {
      let xx = this.getCart?.giftCartList
      if (this.getCurrency.currency !== 'KRW') {
        xx.forEach((e) => {
          const y = e.currencies.find(
            (x) => x.currencyTp === this.getCurrency.currency
          )
          e.listAmt = y.listAmt
          e.saleAmt = y.saleAmt
        })
      }
      return xx
    },
    totalSelectedCount() {
      return this.ebookSelected.length + this.giftSelected.length
    },
    totalPrice() {
      if (!this.getCart) {
        return 0
      }
      return (
        (this.totalSelectedEbookPrice || 0) + (this.totalSelectedGiftPrice || 0)
      )
    },
    totalSelectedEbookPrice() {
      if (!this.ebookSelected) {
        return 0
      }

      return this.ebookSelected.reduce((total, cartItem) => {
        if (cartItem) {
          return total + cartItem.saleAmt
        } else {
          return total
        }
      }, 0)
    },
    totalSelectedGiftPrice() {
      if (!this.podSelected) {
        return 0
      }

      return this.giftSelected.reduce((total, cartItem) => {
        if (cartItem) {
          return total + cartItem.saleAmt
        } else {
          return total
        }
      }, 0)
    },
    totalOrderPrice() {
      return this.totalPrice //+ this.totalDeliveryPrice
    }
  },
  watch: {
    getCart: {
      immediate: true,
      handler() {
        this.initializeSelections()
      }
    }
  },
  created() {
    this.initializeSelections()
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.getCart) {
      this.$store.dispatch(CART_GET_LIST)
    }
    Object.assign(this.$data, initialState())
    next()
  },
  beforeMount() {
    let chkAppUser = navigator.userAgent.toLowerCase()
    if (chkAppUser.indexOf('wv') > 0 || chkAppUser.indexOf('naver') > 0) {
      this.isWebView = true
    }
  },
  mounted() {
    if (!this.getCart) {
      this.$store.dispatch(CART_GET_LIST)
    }
  },
  methods: {
    initializeSelections() {
      if (this.getCart && this.getCart.ebookCartList) {
        if (this.$route.params?.cartCd) {
          this.ebookSelected = this.getCart.ebookCartList.filter(
            (item) => item.cartCd === this.$route.params.cartCd
          )
        } else {
          this.ebookSelected = this.getCart.ebookCartList.slice()
        }

        this.allSelected = this.ebookSelected.length === this.getEbook.length
      }
      if (
        this.getCart &&
        this.getCart.giftCartList &&
        this.getCart.ebookCartList.length == 0
      ) {
        this.giftSelected = this.getCart.giftCartList.slice()
        this.allGiftSelected = this.giftSelected.length === this.getGift.length
      }
    },
    setDefault() {
      this.allSelected = true
      this.ebookSelected = []
    },
    toggleErrorModal(msg) {
      this.showErrorModal = !this.showErrorModal
      this.customErrMsg = msg || false
    },
    toggleCompleteModal(msg, subMsg) {
      this.showCompleteModal = !this.showCompleteModal
      this.completeMsg = msg
      this.completeSubMsg = subMsg
    },

    async toOrderStep2(isGift) {
      if (this.isWebView) {
        this.toggleErrorModal(
          '※현재 접속하신 앱에서는 결제 기능이 지원되지 않습니다. \n 원활한 결제를 위해 Chrome, Safari, 또는 \n 삼성 브라우저를 사용해주시기 바랍니다.'
        )
        return
      }
      // 모바일 app중 webview로 띄운 것들
      if (!this.eBookSelectedValid) {
        this.toggleErrorModal()
        return
      }
      if (!this.ebookSelected.length && !this.giftSelected.length) {
        this.toggleErrorModal()
        return
      }

      const selectedItems = {
        ebook: await this.ebookSelected.map((e) => e.cartGoodsSeq),
        gift: await this.giftSelected.map((e) => e.cartGoodsSeq)
      }
      if (isGift) {
        if (this.ebookSelected.length) {
          this.buyCurrentTp = 'GFT'
          this.toggleCompleteModal(
            '선물하기시 구매 상품을 포함할 수 없습니다.',
            '아래 확인을 눌러 구매상품제외 후 결제 진행해주세요.'
          )
          this.selectAll(false)
          this.allSelected = false
          return
        }
        const x = this.giftSelected.map((e) => e.bookCd)
        const duplicate = [...new Set(x)]
        if (x.length !== duplicate.length) {
          this.toggleErrorModal(
            '중복된 도서가 있습니다. 원하시는 구매 타입을 선택 후 진행 하여주세요.'
          )
          return
        }
        this.$router.push({
          name: 'delivery_info',
          params: { selectedItems }
        })
      } else {
        if (this.giftSelected.length) {
          this.buyCurrentTp = 'PMT'
          this.toggleCompleteModal(
            '구매하기시 선물 상품을 포함할 수 없습니다.',
            '아래 확인을 눌러 선물상품제외 후 결제 진행해주세요.'
          )
          this.selectAll(true)
          this.allGiftSelected = false
          return
        }
        const x = this.ebookSelected.map((e) => e.bookCd)
        const duplicate = [...new Set(x)]
        // console.log(x, duplicate)
        if (x.length !== duplicate.length) {
          this.toggleErrorModal(
            '중복된 도서가 있습니다. 원하시는 구매 타입을 선택 후 진행 하여주세요.'
          )
          return
        }
        this.$router.push({
          name: 'delivery_info',
          params: { selectedItems }
        })
      }
    },
    validTerminal() {
      if (this.buyCurrentTp === 'PMT') {
        this.giftSelected = []
        this.toOrderStep2()
        this.toggleCompleteModal()
        return
      }
      this.ebookSelected = []
      this.toOrderStep2(true)
      this.toggleCompleteModal()
    },
    selectAll(isGift) {
      if (isGift) {
        this.allGiftSelected = !this.allGiftSelected
        if (this.allGiftSelected) {
          if (this.ebookSelected.length) {
            this.allSelected = false
            this.ebookSelected = []
          }
          this.giftSelected = this.getCart.giftCartList.slice()
          return
        }
        this.giftSelected = []
        return
      }

      this.allSelected = !this.allSelected
      if (this.allSelected) {
        if (this.giftSelected.length) {
          this.allGiftSelected = false
          this.giftSelected = []
        }
        this.ebookSelected = this.getCart.ebookCartList.slice()
      } else {
        this.ebookSelected = []
      }
    },
    updateAllSelectedStates() {
      this.allSelected = this.ebookSelected.length === this.getEbook.length
      this.allGiftSelected = this.giftSelected.length === this.getGift.length
    },
    handleEbookChange() {
      if (this.giftSelected.length) {
        this.giftSelected = []
        this.allGiftSelected = false
      }
      this.updateAllSelectedStates()
      console.log(this.ebookSelected)
    },
    handleGiftChange() {
      if (this.ebookSelected.length) {
        this.ebookSelected = []
        this.allSelected = false
      }
      this.updateAllSelectedStates()
    },
    updateQuantity(cartItem, actionType) {
      if (this.isCartLoading) {
        return
      }
      if (actionType === 'MINUS' && cartItem.units === 1) {
        return
      }

      const data = {
        purchase: {
          updateCart: {
            updateTp: actionType,
            cartCd: cartItem.cartCd,
            cartGoodsSeq: cartItem.cartGoodsSeq,
            units: 1,
            goodsOptTp: cartItem.goodsOptTp,
            goodsTp: cartItem.goodsTp,
            bookSaleTp: cartItem.bookSaleTp
          }
        }
      }
      this.$store.dispatch(CART_UPDATE_ITEM, { data })
    },
    removeSelected() {
      if (!this.giftSelected.length && !this.ebookSelected.length) return
      if (this.isCartLoading) return

      let removeList = {}
      this.ebookSelected.map((cartItem) => {
        if (!removeList[cartItem.cartCd]) {
          removeList[cartItem.cartCd] = [cartItem.cartGoodsSeq]
        } else {
          removeList[cartItem.cartCd].push(cartItem.cartGoodsSeq)
        }
      })
      this.giftSelected.map((cartItem) => {
        if (!removeList[cartItem.cartCd]) {
          removeList[cartItem.cartCd] = [cartItem.cartGoodsSeq]
        } else {
          removeList[cartItem.cartCd].push(cartItem.cartGoodsSeq)
        }
      })
      this.$store.dispatch(CART_REMOVE_ITEM, removeList)
      this.setDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
.cart_st .gap {
  float: none;
}
.btnWrap {
  padding: 0px 25px 0px 25px;
}
.complete-wrap {
  display: flex;
  justify-content: space-between;
  .box_btn {
    width: 100%;
  }
}
.ico_cart_pod {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  vertical-align: middle;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17 2V1L15 1V2H13V1L11 1V2H9V1L7 1V2H4.84961C4.24961 2 3.84961 2.4 3.84961 3V21C3.84961 21.6 4.24961 22 4.84961 22H18.8496C19.4496 22 19.8496 21.6 19.8496 21V3C19.8496 2.4 19.4496 2 18.8496 2H17ZM7 4H5.84961V20H17.8496V4H17V5H15V4H13V5H11V4H9V5H7V4Z' fill='black'/%3E%3Cpath d='M16 10H8V12H16V10Z' fill='black'/%3E%3Cpath d='M12 14H8V16H12V14Z' fill='black'/%3E%3C/svg%3E%0A");
}
.meta_title {
  -webkit-box-orient: unset;
  overflow: unset;
  height: auto !important;
}
.info_wrap {
  vertical-align: baseline !important;
}
.num_ctrl {
  position: static !important;
}
.meta_option {
  color: $h_sub_blue2;
  font-size: 1em;
}
.check_all_box {
  padding: 0;
  margin-top: 24px;
}
.text_label {
  display: inline-block;
  label {
    display: flex;
  }
}
img {
  width: 100%;
}
[data-detail*='cart_detail'] .check_all {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text_label {
    label {
      align-items: center;
    }
  }
  &::after {
    content: none;
  }
  .select_del {
    width: auto;
  }
}
.cart_st {
  .box_btn {
    width: auto;
    .an_t {
      font-size: 16px;
      line-height: 47px;
    }
  }
}
[data-detail*='cart_detail'] .btn_wrap[data-detail*='btn_bottom'] {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.gift_btn {
  flex: 0.2;
  height: 56px;
  background-color: #cccccc;
  border-radius: 7px;
  letter-spacing: 0.6px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
.buy_btn {
  flex: 0.3;
  height: 56px;
  background-color: #006fb9;
  border-radius: 7px;
  letter-spacing: 0.6px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
.base_FT14 {
  display: block;
  text-align: center;
  font-family: 'pretendard-light';
  font-size: 18px;
  line-height: 26px;
  color: #008df3;
}
@media (max-width: 768px) {
  .meta_option {
    display: block;
  }
}
@media (max-width: 480px) {
  .ly_inner .box_btn {
    height: 40px;
    .an_t {
      line-height: 40px;
    }
  }
  .division_line {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 10px;
    margin: 35px 0 30px 0;
    padding: 0 25px;
    white-space: nowrap;
    font-size: 16px;
    font-family: 'pretendard-medium';
    color: #125c83;
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: #e5e5e5;
    }
  }
  .order_selected_wrap {
    padding: 25px 25px;
    background-color: #f0f5fa;
    span {
      font-size: 18px;
      font-weight: 500;
      color: #222;
      &.choice_item {
        margin-right: 10px;
      }
    }
  }
  .layout {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 25px;
    padding: 0 25px;
    &::after {
      content: none;
    }
  }
  .text_label {
    label {
      display: flex;
      align-items: center;
    }
  }
  .selected_remove {
    font-size: 13px;
    color: #125c83;
    padding: 7px 10px;
    border: 1px solid #d5dff3;
    font-family: 'pretendard-medium';
    font-weight: 600;
    border-radius: 3px;
  }
  .chk_wrap {
    display: flex;
    align-items: center;
    gap: 30px;
  }
  .total_selected {
    font-family: 'pretendard-medium';
    font-size: 16px;
    color: #36a5c2;
  }
  .cart_list {
    padding: 0 25px;
    li {
      margin-bottom: 10px;
    }
  }
  .checkinput {
    display: none;
    &.all {
      + label::after {
        content: none;
      }
      + label::before {
        content: '';
        width: 22px;
        height: 22px;
        background: url('../../assets/images/login_join/circle_check.png')
          no-repeat;
        background-size: cover;
      }
      &:checked + label::before {
        background: url('../../assets/images/login_join/circle_checked.png')
          no-repeat;
        background-size: cover;
        width: 22px;
        height: 22px;
      }
    }
    & + label {
      display: flex;
      align-items: center;
      gap: 5px;
      font-family: 'pretendard-medium';
      color: #333;
      font-size: 16px;
      cursor: pointer;
      &::after {
        content: '';
        width: 22px;
        height: 22px;
        background: url('../../assets/images/login_join/circle_check.png')
          no-repeat;
        background-size: cover;
      }
    }
    &:checked + label::after {
      background: url('../../assets/images/login_join/circle_checked.png')
        no-repeat;
      background-size: cover;
      width: 22px;
      height: 22px;
    }
  }
  .item_box {
    label {
      justify-content: space-between;
      padding: 25px 25px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
    }
  }
  .cover_wrap {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .info_wrap {
    display: flex;
    flex-direction: column;
    .book_title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      width: 120px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 15px;
    }
    .meta_option {
      margin-top: 5px;
      font-size: 15px;
    }
    .meta_price {
      color: #333;
    }
  }
  .thum_wrap {
    display: block;
    width: 75px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 30%);
    }
  }
  [data-detail*='cart_detail'] .btn_wrap[data-detail*='btn_bottom'] {
    padding: 0 25px;
    justify-content: space-between;
    gap: 7px;
    &.center {
      justify-content: center;
    }
  }
  .gift_btn {
    flex: 0.4;
    height: 40px;
    font-size: 14px;
  }
  .buy_btn {
    flex: 0.6;
    height: 40px;
    font-size: 14px;
  }
}
</style>
